module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group d-flex"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customBusinessType.name),
      expression: "customBusinessType.name"
    }],
    staticClass: "w-50",
    attrs: {
      "type": "text",
      "placeholder": "name here"
    },
    domProps: {
      "value": (_vm.customBusinessType.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customBusinessType, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customBusinessType.description),
      expression: "customBusinessType.description"
    }],
    staticClass: "w-100",
    attrs: {
      "placeholder": "description here"
    },
    domProps: {
      "value": (_vm.customBusinessType.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customBusinessType, "description", $event.target.value)
      }
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1bb9ba7f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb9ba7f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/customBusinessTypes/customBusinessTypeForm.vue
// module id = 2325
// module chunks = 0